export const imageSizes: number[] = [1920, 1280, 1000, 768, 640, 320];
